module.exports = __webpack_public_path__ + "img/9_49.086eab19.png";